import { Amount, decimalsToWei } from '@akropolis-web/primitives';

import { MaybeEither, toEither } from 'utils/either';

export function amountToAccessorValue(value: Amount): number;
export function amountToAccessorValue(value: MaybeEither<Amount | null>): number | undefined;
export function amountToAccessorValue(value: MaybeEither<Amount | null>): number | undefined {
  return toEither(value).fold(
    amount => amount?.div(decimalsToWei(amount?.currency.decimals || 0)).toNumber() ?? undefined,
    () => undefined,
  );
}
